import { useEffect, useState } from 'react';
import { getBusinessInfo } from 'api/paymentSetup';
import { BusinessInfo, RepresentativeAndPersonalInfo } from 'types/paymentSetup';

type IBusinessInfo = Omit<BusinessInfo, 'representativeAndPersonalInfoReqList'> & {
    representativeAndPersonalInfos?: RepresentativeAndPersonalInfo[];
};

export const useBusinessInfo = (): [IBusinessInfo, boolean, () => void] => {
    const [loading, setLoading] = useState(false);
    const [serviceData, setServiceData] = useState<IBusinessInfo>({});

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getBusinessInfo();
            if (!result.error) {
                const data: IBusinessInfo = result?.data?.data || {};
                setServiceData(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    return [serviceData, loading, fetchData];
};
